export enum DialogId {
  CONNECT_EMPLOYEE = 'connectEmployee',
  EDIT_ROUTE = 'editRoute',
  CONNECT_SCHEDULE_RECURRING = 'connectScheduleRecurring'
}
